import { adfModelTypeMap } from './../../registries/consts/adf-model-type-map-const';
import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';

@Metamodel.model({
    name: adfModelTypeMap.sapBw.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.SapBW_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.SapBW_DisplayText)
    ]
})
export class SapBwLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_Host
    })
    public server?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Port
    })
    public systemNumber?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Sid
    })
    public clientId?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_UserName
    })
    public userName?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public password?: string | AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
